module.exports = __webpack_public_path__ + "img/changzhou01.173944e6.png";